export default "__VITE_ASSET__53Qz$3fQ__"